import { PropsCell } from '../common/Table/TableHeader';

export const headCells: PropsCell[] = [
  { id: 'id', numeric: false, disablePadding: false, label: 'ID' },
  { id: 'name', numeric: false, disablePadding: false, label: 'Nombre' },
  { id: 'address', numeric: false, disablePadding: false, label: 'Dirección' },
  {
    id: 'barcode',
    numeric: false,
    disablePadding: false,
    label: 'Código',
  },
  {
    id: 'status_warehouses_id',
    numeric: false,
    disablePadding: false,
    label: 'Activo',
  },
  { id: 'actions', numeric: true, disablePadding: false, label: 'Acciones' },
];

export const fieldsFilter = [
  { key: 'id', name: 'Id de Almacen' },
  { key: 'name', name: 'Nombre' },
  { key: 'address', name: 'Dirección' },
  { key: 'barcode', name: 'Código de barras' },
];
